import {Box, Button, styled, Heading5, ArrowBackIcon} from '../../../ui-library';

export const PageBox = styled(Box)`
    display: flex;
    width: 720px;
    margin: 0 auto;
    padding-top: 77px;
    flex-direction: column;
`;

export const TitlesBox = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
`;


export const Title = styled(Heading5)`
    ${({ theme }) => theme.typography.h5};
    margin-top: 4px;
    margin-bottom: 20px;
`;

export const BackBox = styled(Box)`
    display: flex;
    flex-direction: row;
    height: 30px;
    color:${({ theme }) => theme.palette.primary.main};
    cursor: pointer;
    width: fit-content;
`;

export const BackIcon = styled(ArrowBackIcon)`
    align-self: center;
    font-size: 18px;
    &:hover{
        background-color: #FFFFFF;
    }
`;
export const BackBtn = styled(Button)`
    ${({ theme }) => theme.typography.button};
    font-size: 12px;
    padding-left: 11px;
`;
